@if(_appConfig.appConfig.envTypeEnum === EnvTypeEnum.Development || _appConfig.appConfig.envTypeEnum ===
EnvTypeEnum.Staging){
@if(_appConfig.appConfig.envTypeEnum === EnvTypeEnum.Development){
<div class="w-full mr-3">
    <span class="border-1 border-dashed bg-red-600 border-white border-round-sm font-medium text-lg p-2">DEVELOPMENT SITE</span>
</div>
}
@if(_appConfig.appConfig.envTypeEnum === EnvTypeEnum.Staging){
<div class="w-full mr-3">
    <span class="border-1 bg-blue-600 border-dashed border-white border-round-sm font-medium text-lg p-2">STAGING SITE</span>
</div>
}
}